import React from 'react';
import { AvTag } from '@fabric-ui/components';
import { AiMagic } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';

const IncidentTypeFieldFormatter = ({ value }: { value: string }) => {
  const isAI = value?.toLowerCase() === 'ai';
  return (
    <AvTag
      sx={{ ...flex.row, gap: '1px', width: 'fit-content' }}
      isActive={isAI}
      text={
        <>
          {isAI && <AiMagic />}
          {value}
        </>
      }
    />
  );
};

export default IncidentTypeFieldFormatter;
